import { useEffect, useState } from 'react';

//components
import { Card } from 'primereact/card';

//api
import { ProjectManagementService } from '../../../service/projectmanagement-service';

        

const ProjectCard = ()=>{
    const [projects,setProjects]= useState(0)

    useEffect(()=>{
        const fetchProjects = ()=>{
            ProjectManagementService.getAllProjects(
                (data)=>{
                    setProjects(data.count)
                },
                (error) => {
                    console.error("Errore durante il recupero dei progetti: ", error);
                    
                }
            )
        }
        fetchProjects()
    },[])

    return (
        <div>
            <Card title="Progetti" className='dashboard__ProjectsWrapper'>
                <div className='dashboard__CardContent'>
                    <div>
                     {projects}
                    </div>
                    <div>
                       <i className='pi pi-folder-open'></i> 
                    </div>
                </div>
                <div className='dashboard__Link'>
                    <a href='/dashboard/projects'>Vai ai progetti <i className='pi pi-arrow-right' ></i></a>
                </div>
            </Card>
        </div>
    )
}

export default ProjectCard